<template>
    <div id="materDeliveryManage">
        <el-form ref="searchForm" style="width:100%" :inline="true" :model="searchForm" :label-position="labelPosition">
            <el-form-item style="width:150px;margin-bottom:15px">
                <el-select v-model="searchForm.verificationType" placeholder="请选择盘点类型" clearable>
                    <el-option v-for="(item,index) in pickingList"
                        :label="item.paraName"
                        :value="item.paraValue"
                        :key="index">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item style="width:150px;margin-bottom:15px">
                <el-input clearable v-model.trim="searchForm.code" placeholder="请输入盘点编号"></el-input>
            </el-form-item>
            <el-form-item style="width:150px;margin-bottom:15px">
                <el-select filterable clearable v-model.trim="searchForm.createUser" placeholder="请选择操作人">
                    <el-option v-for="(item,index) in operatorUserAllList"
                        :label="item.staffName"
                        :value="item.staffName"
                        :key="index">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item style="width:150px;margin-bottom:15px">
                <el-input clearable v-model.trim="searchForm.verificationName" placeholder="请输入盘点仓库/工程师"></el-input>
            </el-form-item>
            <el-form-item style="margin-bottom:15px;width:350px">
                <el-date-picker
                    style="width: 100%;"
                    v-model="valueTime3"
                    type="daterange"
                    range-separator="-"
                    :default-time="['00:00:00', '11:59:59']"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item style="margin-bottom: 15px;">
                <el-button type="primary" size="medium" @click="onSubmit('searchForm')">查询</el-button>
                <el-button type="text" @click="clearFrom()" style="width: 60px;color: #169BD5;">重置</el-button>
            </el-form-item>
            <el-form-item class="fr">
                <el-col style="text-align:right">
                    <el-button size="medium" type="success" v-if="basicsAuth.verificationAdd" @click="createOrder()">新建盘点</el-button>
                    <el-button type="success" size="medium" @click="downLoad.exportExcel('tableId')">导出</el-button>
                    <i class="el-icon-refresh" style="font-size: 25px;cursor: pointer;margin-left: 30px;" @click="refresh()"></i>
                </el-col>
            </el-form-item>
        </el-form>
        <el-col>
            <el-card class="box-card" style="width: 100%;">
                <el-table
                    :data="returnData"
                    border
                    id="tableId"
                    :header-cell-style="{'text-align':'center'}"
                    style="width: 100%"
                    @row-click="goToDetail">
                    <el-table-column
                        align="center"
                        prop="code"
                        label="盘点编号">
                    </el-table-column>
                    <el-table-column
                        prop="verificationType"
                        align="center"
                        label="盘点类型">
                        <template slot-scope="scope">
                            <span v-if="scope.row.verificationType == 1">仓库盘点</span>
                            <span v-if="scope.row.verificationType == 2">工程师盘点</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="name"
                        label="盘点仓库/工程师">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="verificationStatus"
                        label="盘点状态">
                        <template slot-scope="scope">
                            <span v-if="scope.row.verificationStatus == 1">盘点中</span>
                            <span v-if="scope.row.verificationStatus == 2">已完成</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="staffName"
                        label="操作人">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="createTime"
                        label="盘点时间">
                    </el-table-column>
                </el-table>
            </el-card>
            <!--分页-->
            <el-col :span="24" class="toolbar">
                <div class="pagination">
                    <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pages.page"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="pages.pageSize"
                        layout="total, sizes, prev, pager, next,jumper"
                        :total="pages.total">
                    </el-pagination>
                </div>
            </el-col>
        </el-col>
    </div>
</template>

<script>
    let moment = require("moment");
    import {
        selectParameterInfoBusiness,
        verificationList,
        queryUser
    } from "../../api/api";
 import {getPermission} from '../../api/authRequest'
    export default {
        name: 'stockCheck',
        components: {
        },
        data () {
            return {
                choose:{},
                deptId:'',  //门店类型
                pickingList:[],
                valueTime3:[],
                //分页变量
                pages:{
                    total: 0,
                    page: 1,
                    pageSize: 10,
                },
                labelPosition:'left',
                searchForm:{
                    verificationType:'', //盘点类型 (1:仓库盘点，2:工程师盘点)
                    createTimeFrom:'', // 创建时间（起）
                    createTimeTo:'', //创建时间（止）
                    code: '',      //盘点编号
                    operator:'',   //接收人
                    shopInput:'',  //收货门店
                    operator:'',   //接收人
                    createUser: '', //创建人
                },
                returnData: [],
                operatorUserAllList:[],
                basicsAuth:{
                    verificationAdd:false
                }
            }
        },
        created:function(){
            this.basicsAuth.verificationAdd = getPermission('/api/verification/verification_add');
            this.deptId = JSON.parse(localStorage.getItem('userInfo')).deptId;
            this.getCheckType();
            this.selectVerificationList();
            this.getOperatorUserAllList();
        },
        mounted () {


        },
        methods: {
            getOperatorUserAllList(){
                queryUser({type:2}).then(res => {
                    if (res.data.status==100) {
                        this.operatorUserAllList = res.data.results
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            clearFrom(){
                this.searchForm = {}
                this.valueTime3 = []
            },
            //获取盘点类型
            getCheckType(){
                let para = {
                    paraType:'verification_type'
                }
                selectParameterInfoBusiness(para).then(res =>{
                    if (res.data.status==100) {
                        this.pickingList = res.data.results.list
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error)=>{
                    this.$Message.error(error.message);
                })
            },
            //获取采购管理列表
            selectVerificationList(){
                let para={
                    verificationType:this.searchForm.verificationType,//配送类型 1:配送发货&2:配送收货
                    createTimeFrom:this.searchForm.createTimeFrom, // 创建时间（起）
                    createTimeTo:this.searchForm.createTimeTo, //创建时间（止）
                    code: this.searchForm.code,      //编号
                    createUser: this.searchForm.createUser, //创建人
                    startRow: this.pages.page,
                    pageSize: this.pages.pageSize
                }
                verificationList(para).then(res => {
                    if (res.data.status==100) {
                        this.returnData = res.data.results.list
                        this.returnData.forEach((item,index)=>{
                            item.createTime = this.filters.formatDate(item.createTime)
                        })
                        this.pages.total = res.data.results.total
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //金额转化函数
            addCommas:function(row,column){
                var num = row[column.property];
                var b= num.toString().replace(/\$|\,/g,'');
                if(isNaN(num))
                num = "0";
                var sign = (num == (num = Math.abs(num)));
                num = Math.floor(num*100+0.50000000001);
                var cents = num%100;
                num = Math.floor(num/100).toString();
                if(cents<10)
                cents = "0" + cents;
                for (var i = 0; i < Math.floor((num.length-(1+i))/3); i++)
                num = num.substring(0,num.length-(4*i+3))+','+
                num.substring(num.length-(4*i+3));
                return (((sign)?'':'-') + num + '.' + cents);
            },
            //时间转化函数
            dateFormat:function(row, column) {
                var date = row[column.property];
                if (date == undefined) {
                    return "";
                }
                return moment(date).format("YYYY-MM-DD");
            },
            handleSizeChange(val) {
                this.pages.pageSize = val
                this.selectVerificationList()
            },
            handleCurrentChange(Page) {
                this.pages.page = Page
                this.selectVerificationList()
            },
            // 进入详情页面
            goToDetail(row) {
                this.$router.push({
                    path:'/stockCheckInfo',
                    query:{
                        orderId:row.id
                    }
                })
            },
            //新建采购订单
            createOrder() {
                this.$router.push({
                    path:'/newStockCheck'
                })
            },
            refresh() {
                this.searchForm = {}
                this.selectVerificationList()
            },
            newSupplierSubmit() {
                alert('确认提交')
            },
            onSubmit(formname) {
                this.$refs[formname].validate((valid) => {
                if (valid) {
                    if(this.valueTime3 == null){
                        this.searchForm.createTimeFrom = ''
                        this.searchForm.createTimeTo = ''
                    }else if (this.valueTime3.length == 0) {
                        this.searchForm.createTimeFrom = ''
                        this.searchForm.createTimeTo = ''
                    }else{
                        this.searchForm.createTimeFrom = this.moment(this.valueTime3[0]).format("YYYY-MM-DD");
                        this.searchForm.createTimeTo = this.moment(this.valueTime3[1]).format("YYYY-MM-DD");
                    }
                    this.selectVerificationList()

                } else {
                    console.log('验证未通过');
                    return false;
                }
            });
        }
    },
    computed: {
    },
    watch: {
    }
}
</script>

<style type="text/css" lang="scss" scoped>
    #materDeliveryManage{font-size: 14px;
        .headerT{margin:10px 0 15px 0;}
        tr.el-table__row{cursor: pointer;}
        input.el-input__inner{padding-right:25px; }
    }
</style>



// WEBPACK FOOTER //
// stockCheck.vue?4406a04d